export const portalConfig: Record<
  string,
  {
    action: "REDIRECT" | "REDITRECT_CMS";
    url?: string;
    options?: { label: string; url: string }[];
  }
> = {
  CDRS: {
    action: "REDIRECT",
    url: "https://www.everlinkdigitalservices.com/",
  },
  CMS: {
    action: "REDITRECT_CMS",
    url: import.meta.env.VITE_CMS_REDIRECT_URL,
  },
  CWS: { action: "REDIRECT", url: "https://cws-everlink.ca/default.asp" },
  DATAVIEW: {
    action: "REDIRECT",
    url: "https://www.everlinkdataview.ca/Login?ReturnUrl=%2f",
  },
  ECONNECT: {
    action: "REDIRECT",
    url: "https://econnect.nonprd.everlinkdigitalservices.com/cps/view/scrt/logn.xhtml",
  },
  EDATA: { action: "REDIRECT", url: "https://cws-everlink.ca:8448/" },
  ESP: {
    action: "REDIRECT",
    url: "https://www.everlink-infomanager.ca/Esp/Setl/Common/Html/IndexFront.html",
  },
  INFOMANAGER: {
    action: "REDIRECT",
    url: "https://www.everlink-infomanager.ca/everlink-infomanager/Login.aspx",
  },
  PRM: {
    action: "REDIRECT",
    url: "https://www.everlinkdataview.ca:8449/ar/login",
  },
  ROCKETHUB: {
    action: "REDIRECT",
    url: "https://prx.everlink-infomanager.ca:8449/ZLUX/plugins/com.rs.bzw/web/",
  },
  VYNAMICVIEW: {
    action: "REDIRECT",
    options: [
      {
        label: "Web Console",
        url: "https://www.everlink-ams.ca:8443/authentication-service/ui/login",
      },
      {
        label: "Desktop Version",
        url: "https://www.everlink-ams.ca:8443/Console/",
      },
    ],
  },
  WEBFTS: {
    action: "REDIRECT",
    url: "https://finserv-mississauga-everlink.ca/default.htm",
  },
  VISACARDINAL: {
    action: "REDIRECT",
    url: "https://www.visaonline.com/login/",
  },
};

export const CONTACT_US_URL =
  "https://everlinkpaymentservices.zendesk.com/hc/en-us/requests/new";
